/**
 * @author Álvaro Fuentes <alvaro.fuentes.zurita@gmail.com>
 */
export const API_PUBLIC_KEY =
  'n24XC8ITlE5I0IpZfra5KHta2taF7l6aXhhziFBNj9jZGj7DCHk0pr4DKrWwuwK2MCkjOIp1klRQmY7pLrEyduCbpODWgHKuaXlmSWOCl9mzjXsSfjDurUOOQ4JhoSpt';
